// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthenticatedLayout_content__2mYQE","inputText":"AuthenticatedLayout_inputText__13_xA","error":"AuthenticatedLayout_error__2Tixn"};